import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { PropsWithChildren, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'

import { ApiClientProvider } from '@app/api/api-client-context'
import { AuthProvider } from '@app/auth/auth-context'
import { ToastProvider } from '@shared/ui/toast'

export const AppProviders = ({ children }: PropsWithChildren) => {
	const [queryClient] = useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: {
						staleTime: 30_000,
						retry: 1,
						refetchOnWindowFocus: false,
					},
					mutations: {
						retry: 0,
					},
				},
			}),
	)

	return (
		<QueryClientProvider client={queryClient}>
			<AuthProvider>
				<ApiClientProvider>
					<BrowserRouter><ToastProvider>{children}</ToastProvider></BrowserRouter>
				</ApiClientProvider>
			</AuthProvider>
		</QueryClientProvider>
	)
}
